import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/content/photos/new',
    owner: '/home',
    authority: 'photosItemAdd',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/content/photos/:id/mod',
    owner: '/home',
    authority: 'photosItemMod',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
];